
export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8">
      <div className="w-full px-4 md:px-8 lg:px-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center mb-6">
              <i className="ri-restaurant-2-fill text-3xl bg-gradient-to-r from-pink-400 to-orange-400 bg-clip-text text-transparent"></i>
              <span className="ml-3 text-2xl font-bold" style={{ fontFamily: '"Pacifico", serif' }}>Cooking Studio</span>
            </div>
            <p className="text-gray-400 leading-relaxed mb-6">
              料理を通じて人生を豊かに。<br />
              あなたの料理の夢を応援します。
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full hover:bg-orange-500 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full hover:bg-orange-500 transition-colors cursor-pointer">
                <i className="ri-twitter-x-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full hover:bg-orange-500 transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full hover:bg-orange-500 transition-colors cursor-pointer">
                <i className="ri-youtube-fill text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-6">メニュー</h3>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('hero')} className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">ホーム</button>
              </li>
              <li>
                <button onClick={() => scrollToSection('about')} className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">教室について</button>
              </li>
              <li>
                <button onClick={() => scrollToSection('business')} className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">受講コース紹介</button>
              </li>
              <li>
                <button onClick={() => scrollToSection('testimonials')} className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">お客様の声</button>
              </li>
              <li>
                <button onClick={() => scrollToSection('recruit')} className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">求人情報</button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">お問い合わせ</button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-6">コース案内</h3>
            <ul className="space-y-3">
              <li className="text-gray-400">基礎料理コース</li>
              <li className="text-gray-400">プロフェッショナルコース</li>
              <li className="text-gray-400">世界の料理コース</li>
              <li className="text-gray-400">製菓・製パンコース</li>
              <li className="text-gray-400">キッズ料理教室</li>
              <li className="text-gray-400">オンラインレッスン</li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-6">お問い合わせ</h3>
            <ul className="space-y-4">
              <li className="flex items-start">
                <i className="ri-map-pin-line text-orange-500 mr-3 mt-1"></i>
                <span className="text-gray-400">〒150-0001<br />東京都渋谷区神宮前3-25-18</span>
              </li>
              <li className="flex items-start">
                <i className="ri-phone-line text-orange-500 mr-3 mt-1"></i>
                <span className="text-gray-400">03-1234-5678</span>
              </li>
              <li className="flex items-start">
                <i className="ri-mail-line text-orange-500 mr-3 mt-1"></i>
                <span className="text-gray-400">info@cookingstudio.jp</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © 2024 Cooking Studio. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <a href="#" className="text-gray-400 hover:text-orange-500 text-sm transition-colors cursor-pointer">プライバシーポリシー</a>
              <a href="#" className="text-gray-400 hover:text-orange-500 text-sm transition-colors cursor-pointer">利用規約</a>
              <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-orange-500 text-sm transition-colors cursor-pointer">Powered by Readdy</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
